import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { Router, browserHistory } from 'react-router';
import ReduxPromise from 'redux-promise';
import ReduxThunk from 'redux-thunk';
import ReactGA from 'react-ga';

import reducers from './reducers';
import routes from './routes';

// for bundling your styles
import './bundle.scss';

// initialize stores
const store = createStore(
    reducers,
    applyMiddleware(ReduxThunk, ReduxPromise)
);

// initialize spa analytics
ReactGA.initialize('UA-100037-7')

function logPageView() {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

ReactDOM.render(
    <Provider store={ store }>
        <Router history={ browserHistory } routes={ routes } onUpdate={ logPageView } />
    </Provider>,
    document.querySelector('.react-root')
);



// WEBPACK FOOTER //
// ./src/app/index.js